import { C1Icon } from 'components/core/icons/C1Icon'
import { Pencil } from 'lucide-react'
import { FC } from 'react'

export const EditIcon: FC<{ className?: string; 'aria-label'?: string }> = ({ className, 'aria-label': ariaLabel = 'edit' }) => {
    return <C1Icon icon={Pencil} className={className} aria-label={ariaLabel} />
}
